import { useState } from "react";
import { MdOutlineSend } from "react-icons/md";

interface ChatMessageInputParams {
  inputEnabled: boolean;
  handleSend: (text: string) => any;
}

const ChatMessageInput: React.FC<ChatMessageInputParams> = ({
  inputEnabled,
  handleSend,
}) => {
  // States definition
  const [inputText, setInputText] = useState<string>("");

  /**
   * Function used when clicking enter or pressed the send icon
   */
  const handleSendWrapper = () => {
    // Prevent execute the send function when it's empty
    if (!inputText) return;

    // If the input text is defined, then send
    handleSend(inputText.trim());
    setInputText("");
  };

  return (
    <div className="w-full h-[70px] bg-Canvas rounded-xl justify-start items-center gap-2 inline-flex relative">
      <input
        id="question-input"
        aria-label="question-input"
        className="w-full h-full p-4 pr-[76px] text-neutral-700 placeholder:text-neutral-300 text-lg font-normal font-sans leading-snug bg-transparent border-none focus:outline-none"
        type="text"
        value={inputText}
        onChange={(event) => setInputText(event.target.value)}
        disabled={inputEnabled}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            handleSendWrapper();
          }
        }}
        placeholder={inputEnabled ? "" : "Please enter your question here"}
      />
      <div
        className={`group absolute right-4 p-3 rounded-[32px] justify-start items-center gap-2 flex ${
          inputText
            ? "hover:bg-neutral-100 ease-in-out duration-150 cursor-pointer"
            : "cursor-not-allowed"
        }`}
        onClick={handleSendWrapper}
      >
        <MdOutlineSend
          className={`w-7 h-7 ${
            inputText
              ? "fill-neutral-300 group-hover:fill-neutral-500"
              : "fill-neutral-200"
          } ease-in-out duration-150`}
        />
      </div>
    </div>
  );
};

export default ChatMessageInput;
